import { graphql } from '@graphql/gql';

export const UPDATE_CONSENT_ANSWER = graphql(`
  mutation UPDATE_CONSENT_ANSWER($consentAnswer: ExhibitorConsentAnswerInput!) {
    updateExhibitorConsentAnswer(consentAnswer: $consentAnswer) {
      answer {
        attendeeId
        questionId
        questionText
        answerId
        choice {
          id
          text
        }
        locale
        lastModifiedDate
      }
    }
  }
`);
